import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import AdminPage from '../shared/AdminPage'
import { useTabsOptions } from '../Advisors/hooks'
import ViewTabs from '../../../organisms/LinkViewTabs'
import { useSearchPermissionGroups } from '../../../../api/users'
import OperationalTable, { useOperationalTable } from '../../../organisms/OperationalTable'
import { useAdminTabStyles } from '../Roles/RolesView'
import { PERMISSIONS } from '../../../../policies/admin'
import { useCheckPolicy } from '../../../../hooks'
import SydButton from '../../../commonDesign/Button'
import PermissionGroupModal from './NewPermissionGroup'

const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'permissionGroupId', type: 'number' },
    { Header: 'Permission Group Name', accessor: 'name', type: 'string' },
    { Header: 'Description', accessor: 'description' },
    {
      Header: 'Number of Permissions',
      Cell: ({ row }) => row.original.permissions.length
    }
  ],
  defaultSort: [{ id: 'permissionGroupId', desc: true }]
}

const PermissionGroups = () => {
  const linkTabOptions = useTabsOptions()
  const history = useHistory()
  const canEditAdvisorRoles = useCheckPolicy(PERMISSIONS.editAdvisorPermissions)
  const classes = useAdminTabStyles()
  const {
    searchText,
    onSearchTextChange
  } = useOperationalTable(defaultColumnConfig.defaultSort)
  const query = {
    includes: {
      permissions: true
    },
    filters: {
      assignableToUserType: 2
    }
  }
  const { data: permissionGroups = [], isLoading } = useSearchPermissionGroups(query)
  const onChangeTab = useCallback(() => {
    onSearchTextChange('')
  }, [onSearchTextChange])
  const onClickRow = useCallback((row) => {
    if (row.original) {
      if (canEditAdvisorRoles) {
        history.push(`/admin/permission-groups/${row.original.permissionGroupId}`)
      }
    }
  }, [canEditAdvisorRoles, history])
  const [modalOpen, setModalOpen] = React.useState(false)
  const onModalSubmit = () => {
    setModalOpen(false)
  }

  return (
    <AdminPage>
      <PermissionGroupModal open={modalOpen} handleClose={onModalSubmit} permissionType={2} />
      <ViewTabs.Group tabOptions={linkTabOptions} onChange={onChangeTab}>
        <ViewTabs.Links
          tabsKey='advisors'
          rightAdornment={canEditAdvisorRoles && (
            <SydButton
              variant='primary'
              size='md'
              icon='add'
              onClick={() => setModalOpen(true)}
            >
              Add Permission Group
            </SydButton>
          )}
        />
      </ViewTabs.Group>
      <OperationalTable.Wrapper>
        <OperationalTable.SuperHeader className={classes.headspace}>
          <OperationalTable.Search
            onChange={onSearchTextChange}
            placeholder='Search by permission group name'
            delay={250}
          />
        </OperationalTable.SuperHeader>
        <OperationalTable
          variant='v2'
          columns={defaultColumnConfig.columns}
          mode='auto'
          defaultSort={defaultColumnConfig.defaultSort}
          data={permissionGroups}
          searchText={searchText}
          loading={isLoading}
          onRowClick={row => { onClickRow(row) }}
        />
      </OperationalTable.Wrapper>

    </AdminPage>
  )
}

export default PermissionGroups
